import {
  FETCH_LIC_CERTS_OPTIONS,
  FETCH_LIC_CERTS_OPTIONS_SUCCESS,
  FETCH_LIC_CERTS_OPTIONS_ERROR,
} from '../actions';

const initialState = {
  isFetching: false,
  licenseCert: {
    1: { items: [], body: [] },
    2: { items: [], body: [] },
    3: { items: [], body: [] },
  },
};

const candidates = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_LIC_CERTS_OPTIONS:
      return {
        ...state,
        isFetching: true,
      };
    case FETCH_LIC_CERTS_OPTIONS_SUCCESS: {
      const { licenseCert } = state;
      return {
        ...state,
        isFetching: false,
        licenseCert: {
          ...licenseCert,
          [action.occupationId]: action.data,
        },
      };
    }
    case FETCH_LIC_CERTS_OPTIONS_ERROR:
      return {
        ...state,
        isFetching: false,
      };
    default:
      return state;
  }
};

export default candidates;
